import { render } from "./My.vue?vue&type=template&id=163d59f9&scoped=true"
import script from "./My.vue?vue&type=script&lang=js"
export * from "./My.vue?vue&type=script&lang=js"

import "./My.vue?vue&type=style&index=0&id=163d59f9&lang=scss&scoped=true"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163d59f9"]])

export default __exports__